import { TRANSPORT_BODYTYPE_ADDITIONALS } from "../constants/transport";

export const initializeTransportFields = {
    carrying_capacity: "",
    conics: false,
    country_id: "",
    document: "",
    gidrolift: false,
    height: "",
    length: "",
    own_name: "",
    registration_number: "",
    satellite_monitoring: false,
    trailer_registration_number: "",
    transport_bodytype_additionals_id: "",
    transport_bodytype_ids: [],
    transports_loading_types: "",
    volume: "",
    width: "",
    notes: "",
};

class Transport {
    static initFormData(data) {
        const formData = {};
        for (let item in data) {
            if (data[item] !== null) {
                formData[item] = data[item];
            }
        }
        if (formData.transports_loading_types?.length > 0) {
            formData.transports_loading_types = formData.transports_loading_types.map(
                (item) => item.loading_type?.id || item.id || item,
            );
        }
        // Convert transport_bodytypes array of objects to transport_bodytype_ids array of IDs
        if (formData.transport_bodytypes?.length > 0) {
            formData.transport_bodytype_ids = formData.transport_bodytypes.map(
                (item) => item.id || item,
            );
        }
        if (formData.transport_bodytype_additionals_id) {
            formData.transport_bodytype_additionals_id = String(
                formData.transport_bodytype_additionals_id,
            );
        }

        return formData;
    }

    static formData(data) {
        const formData = {};
        for (let item in data) {
            if (item !== "document" && item in initializeTransportFields) {
                formData[item] = data[item];
            }
        }
        formData.id = data.id;

        if (
            formData.transport_bodytype_additionals_id !== TRANSPORT_BODYTYPE_ADDITIONALS.COUPLING
        ) {
            formData.trailer_registration_number = "";
        }

        if (formData.country_id) {
            formData.country_id = formData.country_id.value;
        } else {
            formData.country_id = [];
        }

        return formData;
    }
}

export default Transport;
